import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=2cf3df31&"
import script from "./UserDetail.vue?vue&type=script&lang=ts&"
export * from "./UserDetail.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VContainer,VDivider,VLayout,VList,VListTile,VListTileContent,VSubheader})
